function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 12,
  fill: "white",
  fillOpacity: 0.15
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2327 11.6346C15.991 11.2469 16.4735 10.5576 16.3615 9.41159C16.215 7.84339 14.9271 7.31779 13.2211 7.17134V5H11.8941V7.11102C11.5494 7.11102 11.1962 7.11963 10.8429 7.12825V5H9.51598V7.17134C9.02811 7.18608 8.45991 7.17889 6.85352 7.17134V8.58441C7.90116 8.56587 8.45086 8.49855 8.5768 9.1703V15.1156C8.49682 15.6486 8.07029 15.5719 7.12061 15.5551L6.85352 17.1319C9.27295 17.1319 9.516 17.1405 9.516 17.1405V19H10.8429V17.1663C11.2048 17.1749 11.5581 17.1749 11.8941 17.1749V19H13.2211V17.1405C15.4441 17.0198 16.9302 16.4598 17.1284 14.366C17.2834 12.6858 16.4907 11.9362 15.2327 11.6346ZM10.8688 8.67918C11.6184 8.67918 13.9621 8.44657 13.9621 10.0061C13.9621 11.4968 11.6184 11.3244 10.8688 11.3244V8.67918ZM10.8688 15.5637V12.6514C11.7649 12.6514 14.509 12.4015 14.509 14.1075C14.509 15.7533 11.7649 15.5637 10.8688 15.5637Z",
  fill: "white"
});
function SvgBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/btc.65acb08d9f1c6f4209060145bb1d1c03.svg";
export { ForwardRef as ReactComponent };